import React from 'react';
import { SubNavigationData, SubNavigationVersion } from '@models/section/subNavigationSection';
import { V1SubNavigation } from '@components/SubNavigation/V1SubNavigation';
import { V2SubNavigation } from '@components/SubNavigation/V2SubNavigation';

export interface SubNavigationProps {
    sectionData: SubNavigationData;
}

export function SubNavigation({ sectionData }: SubNavigationProps): React.ReactElement {
    return (
        <div>
            {sectionData.version === SubNavigationVersion.Buttons ? (
                <V2SubNavigation sectionData={sectionData} />
            ) : (
                <V1SubNavigation sectionData={sectionData} />
            )}
        </div>
    );
}
